const formatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export function toCurrency(numero: number | string): string {
  const num = typeof numero === 'string' ? parseFloat(numero) : numero;
  return formatter.format(num);
}
